import React from "react";
import { Outlet } from "react-router-dom";
import {
  Search, Store, Send, Target, Phone, RotateCcw, Building2,
} from "lucide-react";

/**
 * Layout wrapper for the Prospecting section.
 *
 * The section's navigation lives in the main sidebar (see PROSPECTING_NAV_ITEM
 * in components/layout/Navigation.js), which already reproduces the structure
 * from Christian's Ignite screenshots. Market Update and CMA used to sit here
 * under a "Reports" heading; they moved to their own Reports tab (Monday
 * 13377706735), whose buttons live in features/reports/reportsCatalog.js.
 *
 * This deliberately renders NO second rail of its own. An earlier version had
 * one, which meant the same six links appeared twice on every page and cost
 * about 250px of content width. Ignite needs its rail because its sidebar is a
 * narrow icon strip; ours is a full labelled sidebar, so the rail is redundant.
 *
 * SECTIONS is still exported because it is the single description of what the
 * section contains, and the nav test asserts against it.
 *
 * `comingSoon` marks the rows Christian closed off on 15 Aug 2026 (Monday
 * 12780827140). The sidebar draws them greyed with a SOON pill and ComingSoonRoute
 * closes the route to match.
 */
const SECTIONS = [
  {
    heading: "Prospecting",
    items: [
      {
        to: "/collings-data-properties",
        label: "Public Property Search",
        icon: Search,
        hint: "Every Homer sale, rental, sold and off-market property",
      },
      {
        to: "/prospecting/find-buyers",
        label: "Find Buyers",
        icon: Target,
        hint: "Match a property to your buyer database",
      },
      {
        to: "/prospecting/relisting-opportunities",
        label: "Re-listing Opportunities",
        icon: RotateCcw,
        hint: "Withdrawn and 60+ day competitor listings to win",
      },
      {
        to: "/prospecting/new-developments",
        label: "New Developments",
        icon: Building2,
        hint: "BCI projects in the patch and the developers behind them",
      },
      {
        to: "/garage-sales",
        label: "Garage Sales",
        icon: Store,
        hint: "Vendor-intent signal",
      },
      {
        to: "/communications",
        label: "Communications",
        icon: Send,
        hint: "Email & SMS campaigns",
      },
      {
        to: "/ai-voice-caller",
        label: "AI Voice Caller",
        icon: Phone,
        hint: "AI-powered calling system",
        comingSoon: true,
      },
    ],
  },
];

const ProspectingLayout = () => <Outlet />;

export { SECTIONS as PROSPECTING_SECTIONS };
export default ProspectingLayout;
